export const WELCOME = '/';
export const CHURCHES = '/churches';
export const PASTORS = '/pastors';
export const OUTREACH = '/outreach';
export const CONTACT = '/contact';
export const STAFF = '/staff';
